import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import * as Const from "@utils/Const";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
export default function BoardTree(props) {
    const { menu, items, setItem, } = props;
    let token = localStorage.getItem(Const.TOKEN);
    let lang = localStorage.getItem(Const.LANG_TYPEA);
    let appPath = `?lang=${lang}`;
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/admin/board/list${appPath}`,
        appQuery: {},
        userToken: token,
        watch: appPath,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
            }
        }
    }, [data]);
    const handleView = (e, val) => {
        setItem((prev) => (Object.assign(Object.assign({}, prev), { depth2: val, type: "" })));
    };
    return (_jsx(_Fragment, { children: _jsxs("aside", Object.assign({ className: "product-list" }, { children: [_jsx("h2", { children: "\uC81C\uD488 \uBAA9\uB85D" }), _jsx("ul", { children: menu.map((item) => (_jsx("li", Object.assign({ onClick: (e) => handleView(e, item) }, { children: item.menuName }), item.menuId))) })] })) }));
}
